var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 19,
    viewBox: "0 0 123 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5067 18.5308V0H42.8614V7.25922H35.6354V0H30.9901V18.5308H35.6354V10.902H42.8614V18.5308H47.5067ZM28.6961 3.61647V5.32921e-05H14.0147V3.61647H19.0437V18.5309H23.6671V3.61647H28.6961ZM60.0972 18.5308L56.0854 11.5356H54.9588V18.5308H50.2601V0H58.1462C59.6667 0 60.9581 0.255172 62.0206 0.765517C63.1014 1.27586 63.9074 1.97979 64.4386 2.87729C64.9699 3.7572 65.2355 4.74269 65.2355 5.83378C65.2355 7.06565 64.8691 8.16553 64.1364 9.13343C63.422 10.1013 62.3595 10.7876 60.949 11.1924L65.4004 18.5308H60.0972ZM54.9588 8.34151H57.8715C58.7324 8.34151 59.3736 8.13913 59.7949 7.73438C60.2346 7.32962 60.4544 6.75768 60.4544 6.01856C60.4544 5.31463 60.2346 4.76029 59.7949 4.35554C59.3736 3.95078 58.7324 3.7484 57.8715 3.7484H54.9588V8.34151ZM72.7408 18.5308V0H68.1529V18.5308H72.7408ZM95.2227 0L88.3234 18.5308H82.3938L75.4945 0H80.5374L85.3586 13.9905L90.2075 0H95.2227ZM101.8 7.36481V3.61641H108.985V0H97.0567V18.5308H108.985V14.9144H101.8V10.8492H108.153V7.36481H101.8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.28fecfafaeb52fb0168d10a6f0b12978.svg";
export { ForwardRef as ReactComponent };